const Wishlist = {

  getAll() {
    return JSON.parse(localStorage.getItem('wishlist')) || [];
  },

  save(items) {
    localStorage.setItem('wishlist', JSON.stringify(items));
  },

  add(product) {
    const items = this.getAll();
    const exists = items.find(item => item.id === product.id);
    if (!exists) {
      items.push(product);
      this.save(items);
    }
  },
  remove(productId) {
    let items = this.getAll();
    items = items.filter(item => item.id !== productId);
    this.save(items);
  },

  has(productId) {
    const items = this.getAll();
    return items.some(item => item.id === productId);
  },


  toggle(product) {
    if (this.has(product.id)) {
      this.remove(product.id);
      return false;
    } else {
      this.add(product);
      return true;
    }
  },

  count() {
    return this.getAll().length;
  },


  clear() {
    localStorage.removeItem('wishlist');
  }

};


function initWishlistButtons() {
  const items = Wishlist.getAll();
  if (!items.length) return;
  const ids = new Set(items.map(item => item.id));

  document.querySelectorAll('.wishlist-btn:not(.active)').forEach(btn => {
    if (!ids.has(parseInt(btn.dataset.productId))) return;
    btn.classList.add('active');
    const heart = btn.querySelector('.heart-icon');
    if (heart) heart.innerHTML = heartFilledSVG();
  });
}


function updateWishlistCounter() {
  const count = Wishlist.count();
  const counters = document.querySelectorAll('.wishlist-count');

  counters.forEach(counter => {
    counter.textContent = count;

    if (count > 0) {
      counter.style.display = 'flex';
    } else {
      counter.style.display = 'none';
    }
  });
}



function showToast(message) {
  const existing = document.querySelector('.wishlist-toast');
  if (existing) existing.remove();

  const toast = document.createElement('div');
  toast.className = 'wishlist-toast';
  toast.textContent = message;
  document.body.appendChild(toast);


  setTimeout(() => toast.classList.add('show'), 10);


  setTimeout(() => {
    toast.classList.remove('show');
    setTimeout(() => toast.remove(), 400);
  }, 3000);
}


function heartOutlineSVG() {
  return `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" 
    viewBox="0 0 24 24" fill="none" stroke="currentColor" 
    stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 
    5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 
    1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
  </svg>`;
}

function heartFilledSVG() {
  return `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" 
    viewBox="0 0 24 24" fill="#e74c3c" stroke="#e74c3c" 
    stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 
    5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 
    1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
  </svg>`;
}



function renderWishlistPage() {
  const container = document.querySelector('.wishlist-page-grid');
  if (!container) return; 

  const items = Wishlist.getAll();
  const emptyMsg = document.querySelector('.wishlist-empty');
  const countEl = document.querySelector('.wishlist-total-count');

  // Count update
  if (countEl) countEl.textContent = items.length;

  if (items.length === 0) {
    container.innerHTML = '';
    if (emptyMsg) emptyMsg.style.display = 'block';
    return;
  }

  if (emptyMsg) emptyMsg.style.display = 'none';


  container.innerHTML = items.map(item => `
    <div class="wishlist-card" data-id="${item.id}">

      <div class="wishlist-card__image">
        <a href="${item.url}">
          <img src="${item.image}" alt="${item.title}" loading="lazy"/>
        </a>
        <button class="wishlist-remove-btn" data-id="${item.id}" title="Remove">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" 
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>

      <div class="wishlist-card__info">
        <h3 class="wishlist-card__title">
          <a href="${item.url}">${item.title}</a>
        </h3>
        <p class="wishlist-card__price">${item.price}</p>
        <a href="${item.url}" class="wishlist-card__btn">
          View Product
        </a>
      </div>

    </div>
  `).join('');


  document.querySelectorAll('.wishlist-remove-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const id = parseInt(this.dataset.id);
      Wishlist.remove(id);

     
      const card = document.querySelector(`.wishlist-card[data-id="${id}"]`);
      if (card) {
        card.style.opacity = '0';
        card.style.transform = 'scale(0.9)';
        setTimeout(() => {
          card.remove();
          renderWishlistPage(); 
        }, 300);
      }

      updateWishlistCounter();
    });
  });
}


function initClearAll() {
  const clearBtn = document.querySelector('.wishlist-clear-btn');
  if (!clearBtn) return;

  clearBtn.addEventListener('click', function () {
if (confirm('Are you sure you want to clear your wishlist?')) {
      Wishlist.clear();
      renderWishlistPage();
      updateWishlistCounter();
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initWishlistButtons();   
  updateWishlistCounter(); 
  renderWishlistPage();    
  initClearAll();          
});
function injectWishlistInSearchResults() {
  const searchResultsArea = document.querySelector('.main-search__results');
  if (!searchResultsArea) return;

  const observer = new MutationObserver(function () {
    searchResultsArea.querySelectorAll('.image-cont').forEach(function (cont) {
      if (cont.querySelector('.wishlist-btn')) return;

      const productBlock = cont.closest('[data-product-id]');
      if (!productBlock) return;

      const productId = productBlock.dataset.productId;
      const titleEl = productBlock.querySelector('.product-block__title');
      const priceEl = productBlock.querySelector('.price__current, .price');
      const imgEl = productBlock.querySelector('img');
      const linkEl = productBlock.querySelector('a.product-link');

      const btn = document.createElement('button');
      btn.className = 'wishlist-btn';
      btn.setAttribute('data-product-id', productId);
      btn.setAttribute('data-product-title', titleEl ? titleEl.textContent.trim() : '');
      btn.setAttribute('data-product-price', priceEl ? priceEl.textContent.trim() : '');
      btn.setAttribute('data-product-image', imgEl ? imgEl.src : '');
      btn.setAttribute('data-product-url', linkEl ? linkEl.href : '');
      btn.setAttribute('aria-label', 'Add to wishlist');
      btn.setAttribute('title', 'Add to Wishlist');

      const span = document.createElement('span');
      span.className = 'heart-icon';
      span.innerHTML = Wishlist.has(parseInt(productId))
        ? heartFilledSVG()
        : heartOutlineSVG();

      btn.appendChild(span);
      cont.style.position = 'relative';
      cont.appendChild(btn);
    });
  });

  observer.observe(searchResultsArea, { childList: true, subtree: true });
}

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.wishlist-btn');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const product = {
    id:    parseInt(btn.getAttribute('data-product-id')),
    title: btn.getAttribute('data-product-title'),
    price: btn.getAttribute('data-product-price'),
    image: btn.getAttribute('data-product-image'),
    url:   btn.getAttribute('data-product-url')
  };

  if (!product.id) return;

  const added = Wishlist.toggle(product);
  const heartSpan = btn.querySelector('.heart-icon');

  if (added) {
    btn.classList.add('active');
    if (heartSpan) heartSpan.innerHTML = heartFilledSVG();
    showToast((product.title || 'Product') + ' added to wishlist!');
  } else {
    btn.classList.remove('active');
    if (heartSpan) heartSpan.innerHTML = heartOutlineSVG();
    showToast((product.title || 'Product') + ' removed from wishlist!');
  }

  updateWishlistCounter();
}, true);

document.addEventListener('DOMContentLoaded', injectWishlistInSearchResults);

window.addEventListener('load', initWishlistButtons);